export default {
    LOGIN: "/login",
    EMAIL_CONFIRMATION: "/email-confirmation/:token",
    PASSWORD_FORGOTTEN: "/password-forgotten",
    PASSWORD_RESET: "/password-reset/:token",
    UNSUBSCRIBE: "/unsubscribe",
    HOME: "/home",
    TFA_INPUT: "/tfa-input",
    TFA_SETTINGS: "/tfa-settings",
    PROFILE: "/profile",
    SCREENING: "/home/screening",
    APPOINTMENTS: "/home/appointments",
    APPOINTMENT_CONFIRMATION: (
        params?: AppointmentConfirmationRouteParams
    ): string => {
        if (params) {
            return `/home/appointments/${params.type}/${params.id}/confirmation`;
        }

        return "/home/appointments/:type/:id/confirmation";
    },
    AVAILABILITY: "/availability",
    PREP: "/home/prep",
    SCREENING_APPOINTMENT_CONFIRMATION: (
        params?: ScreeningAppointmentConfirmationParams
    ): string => {
        if (params) {
            return `/home/appointments/screening/${params.id}/screening-appointment-confirmation`;
        }

        return "/home/appointments/screening/:id/screening-appointment-confirmation";
    },
    SIGN_UP: "/signup",
    SHARE: "/share",
};

export interface AppointmentConfirmationRouteParams {
    type: "screening" | "phone";
    id: number;
}

export interface ScreeningAppointmentConfirmationParams {
    id: number;
}
